import { addMethod } from 'yup';
export function enrichYupWrapper(yupWrapper) {
    const addmobileConfigurable = (schema) => addMethod(schema, 'mobileConfigurable', function () {
        return this.meta({
            mobileConfigurable: true,
        });
    });
    addmobileConfigurable(yupWrapper.array);
    addmobileConfigurable(yupWrapper.date);
    addmobileConfigurable(yupWrapper.mixed);
    addmobileConfigurable(yupWrapper.number);
    addmobileConfigurable(yupWrapper.object);
    addmobileConfigurable(yupWrapper.string);
}
//# sourceMappingURL=index.js.map